import { inMarketTheme } from '@inmarket/inmarkit';
import {
  ThemeProvider as BaseThemeProvider,
  createTheme,
  ThemeOptions,
} from '@mui/material';
import { ComponentProps } from 'react';

const buttonTheme = {
  defaultProps: {
    disableElevation: true,
    variant: 'contained',
  },
  styleOverrides: {
    root: {
      borderRadius: '8px',
    },
  },
} as const satisfies NonNullable<ThemeOptions['components']>['MuiButton'];

// TODO: Replace this with UI Kit versions of this once theme adjustments have been released
// as part of the UI Kit that doesn't re-export MUI components
const themeWithOverrides = createTheme({
  ...inMarketTheme,
  components: {
    MuiButtonBase: {
      defaultProps: {
        disableRipple: process.env.NODE_ENV === 'test',
      },
    },
    MuiButton: buttonTheme,
    MuiLoadingButton: buttonTheme,
    MuiAccordion: {
      defaultProps: {
        elevation: 0,
      },
      styleOverrides: {
        root: {
          width: '100%',
          borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
          '&:before': { display: 'none' },
          '&.Mui-expanded': { margin: 0 },
        },
      },
    },
    MuiAccordionSummary: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
          border: 'none',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
          border: '1px solid lightgray',
          borderRadius: '4px',
        },
      },
    },
    MuiPickersYear: {
      styleOverrides: {
        root: {
          '& .MuiPickersYear-yearButton': {
            fontSize: '1rem',
          },
        },
      },
    },
    MuiPickersMonth: {
      styleOverrides: {
        root: {
          '& .MuiPickersMonth-monthButton': {
            fontSize: '1rem',
          },
        },
      },
    },
  },
});

export const ThemeProvider = (
  props: Omit<ComponentProps<typeof BaseThemeProvider>, 'theme'>
) => <BaseThemeProvider {...props} theme={themeWithOverrides} />;
